import {Analytics} from "@/shared/analytics";
import * as Button from "@/shared/utils/button";
import {SecurityStatus} from "@/shared/securityStatus"
import {SecurityStatusDTO, TIMRGlobals} from "@/shared/timr";


// TODO: TIMR-11628 Consolidate global javascript contexts
declare global {
	interface Window {
		Analytics: typeof Analytics;
		Button: typeof Button;
		// Set in globals.jsp from the server-rendered security status.
		__SECURITY_STATUS__?: SecurityStatusDTO;
	}

	const globals: TIMRGlobals;
}

if (typeof window !== 'undefined') {
	// TODO: Need for these two can also be removed with TIMR-11629 Cleanup javascript invocations in setup wizard jsp files
	// Used in setup wizard jsp pages
	window.Analytics = Analytics
	window.Button = Button;

	const securityStatus = window.__SECURITY_STATUS__;
	if (securityStatus) {
		SecurityStatus.update(securityStatus);
		delete window.__SECURITY_STATUS__;
	}
}
